import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export type PersonalInfoState = {
  firstName: string
  lastName: string
  dateOfBirth: string
  nationality: string
  gender: string
  pep: string
  ssn: string
}

const initialState: PersonalInfoState = {
  firstName: "",
  lastName: "",
  dateOfBirth: "",
  nationality: "",
  gender: "",
  pep: "",
  ssn: "",
}

const personalInfoSlice = createSlice({
  name: "personalInfo",
  initialState,
  reducers: {
    updatePersonalInfo: (state, { payload }: PayloadAction<Partial<PersonalInfoState>>) => {
      return {
        ...state,
        ...payload,
      }
    },

    setFirstName: (state, { payload }: PayloadAction<string>) => {
      state.firstName = payload
    },

    setLastName: (state, { payload }: PayloadAction<string>) => {
      state.lastName = payload
    },

    setDateOfBirth: (state, { payload }: PayloadAction<string>) => {
      state.dateOfBirth = payload
    },

    setNationality: (state, { payload }: PayloadAction<string>) => {
      state.nationality = payload
    },

    setGender: (state, { payload }: PayloadAction<string>) => {
      state.gender = payload
    },

    setPep: (state, { payload }: PayloadAction<string>) => {
      state.pep = payload
    },

    setSsn: (state, { payload }: PayloadAction<string>) => {
      state.ssn = payload
    },

    clearPersonalInfo: () => {
      return initialState
    },
  },
})

export const {
  updatePersonalInfo,
  setFirstName,
  setLastName,
  setDateOfBirth,
  setNationality,
  setGender,
  setPep,
  setSsn,
  clearPersonalInfo,
} = personalInfoSlice.actions

export default personalInfoSlice.reducer
